import React from "react";
import { Table } from "components";
import { PREOPERATIVE_TPA, DEGREES } from "./duck";
import styles from "./PreoperativeTpa.module.css";

const PreoperativeTpa: React.FC = () => {
  return (
    <Table
      data={PREOPERATIVE_TPA}
      topCaption="Preoperative Tibial Plateau Angle (TPA)"
      leftCaption="Saw Radius"
      theadProps={{
        bg: "none",
        borderBottom: "6px solid",
        borderColor: "gray.100"
      }}
      className={styles.preopTpa}
    >
      {[
        <Table.Column dataKey="sawRadius" key="sawRadius" label="" />,
        ...DEGREES.map(deg => (
          <Table.Column key={deg} dataKey={`${deg}deg`} label={`${deg}°`} />
        ))
      ]}
    </Table>
  );
};

export default PreoperativeTpa;
